import { createSlice } from '@reduxjs/toolkit'

const initialState = { imageData: [] }

export const imageSlice = createSlice({
  name: 'images',
  initialState,
  reducers: {
    setImages: (state, action) => {
      state.imageData.pop()
      state.imageData.push(action.payload)
    },
    removeImages: (state) => {
      state.imageData = []
    }
  }
})

export const { setImages, removeImages } = imageSlice.actions

export default imageSlice.reducer
